// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1shou","label":"Completed_label__1xUZ_"};